var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:(_vm.$vuetify.breakpoint.sm || _vm.$vuetify.breakpoint.xs) ? (_vm.padre == 0 ? (_vm.$vuetify.breakpoint.sm ? 'chart-mobile2' : 'chart-mobile') : 'chart-mobile-padre') : _vm.padre == 0 ? 'chart-container' : 'chart-container-padre'},[_c('canvas',{attrs:{"id":_vm.id}})]),_c('div',{attrs:{"id":`legend${_vm.id}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }